import { useFormContext } from "react-hook-form";
import { Stack } from "@mantine/core";
import { ChangeEvent } from "react";
import {
  NewOrderAttributes,
  TNewOrderAttributes,
  TNewOrderForm,
} from "@/entities/new-order";
import { DistributeAttribute } from "./distribute-attribute";
import { DelayStartAttribute } from "./delay-start-attribute";
import { LaunchAppAttributes } from "./launch-app-attributes";
import { GoogleAttributes } from "./google-attributes";

export const AttributesBlock = () => {
  const { setValue, watch } = useFormContext<TNewOrderForm>();

  const { attributesList } = watch();

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const attributeValue = event.target.value as TNewOrderAttributes;

    const newValues = attributesList.includes(attributeValue)
      ? attributesList.filter((item) => item !== attributeValue)
      : [...attributesList, attributeValue];

    setValue("attributesList", newValues);
  };

  const handleDeleteAttribute = (attribute: TNewOrderAttributes) => {
    if (attribute === NewOrderAttributes.Day) {
      setValue(
        "attributesList",
        attributesList.filter((attr) => !attr.includes("day")),
      );
      return;
    }

    setValue(
      "attributesList",
      attributesList.filter((attr) => attr !== attribute),
    );
  };

  return (
    <Stack w="100%" gap="md">
      <GoogleAttributes
        attributesList={attributesList}
        handleCheckboxChange={handleCheckboxChange}
        handleDeleteAttribute={handleDeleteAttribute}
      />
      <LaunchAppAttributes
        attributesList={attributesList}
        handleCheckboxChange={handleCheckboxChange}
        handleDeleteAttribute={handleDeleteAttribute}
      />
      <DistributeAttribute
        attributesList={attributesList}
        handleCheckboxChange={handleCheckboxChange}
        handleDeleteAttribute={handleDeleteAttribute}
      />
      <DelayStartAttribute />
    </Stack>
  );
};
